import { Link } from "react-router-dom";
import { articles } from "@/mocks/siteData";

export default function BlogSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-5">
            Expert Guides
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] mb-4">
            Superbuy Spreadsheet
            <br />
            <span className="text-foreground-400 font-normal italic">SEO Articles & Guides</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles to help you master the Superbuy Spreadsheet. From beginner tutorials to advanced shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col rounded-2xl bg-background-50 border border-background-200 hover:border-accent-300 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                    Guide
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug mb-3 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-auto flex items-center gap-2 text-sm font-semibold text-accent-600 group-hover:text-accent-700 transition-colors">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}